import { TextField } from "@mui/material";
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopDatePicker as DatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { Controller } from "react-hook-form";
import _ from "lodash";
import 'moment/locale/es';
import moment from "moment";

//TODO minDate is ok but controller's value is not changing after first render
const CustomDatePicker = ({ form: { control }, name, label, required, minDate, maxDate, manualInput }) => {

  const toFormattedDate = (date) => date?.format("YYYY-MM-DD");
  const labelWithRequired = `${label}${required ? "*" : ""}`;
  
  return (
    <Controller
      control={control}
      name={name}
      rules={{
        required,
        validate: value => (!maxDate || moment(value).isSameOrBefore(maxDate, "day")) && (!minDate || moment(value).isSameOrAfter(minDate, "day"))
      }}
      render={({
        field: { value, onChange },
        fieldState: { error }
      }) => (
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <DatePicker
            label={labelWithRequired}
            value={value}
            onChange={date => onChange(toFormattedDate(date))}
            minDate={minDate}
            maxDate={maxDate}
            inputFormat="DD/MM/YYYY"
            renderInput={(params) => <TextField fullWidth {...params} error={!_.isEmpty(error)} />}
          />
        </LocalizationProvider>
      )}
    />
  );
};

export default CustomDatePicker;